// extracted by mini-css-extract-plugin
export default {"loggedOutToPatients":"LoggedOutToPatients_loggedOutToPatients__s+6pa","textContainer":"LoggedOutToPatients_textContainer__QxpFF"};